import ACCOUNTS_MARKETPLACE_API from 'api/accounts-marketplace/v1'
import { FETCH_PRODUCTS, SET_DATA, SET_LOADING } from 'modules/AccountsMarketplace/Products/types'
import { call, put, takeLatest } from 'redux-saga/effects'

function* onLoadData({ payload }) {
  try {
    yield put({ type: SET_LOADING, payload: { loading: true } })

    const { response, error } = yield call(
      ACCOUNTS_MARKETPLACE_API.fetchProducts,
      {
        params: payload.params,
      },
    )

    if (error) {
      throw error
    }

    yield put({
      type: SET_DATA,
      payload: response.data,
    })
  } catch (error) {
    console.logXHR(error)
  } finally {
    yield put({ type: SET_LOADING, payload: { loading: false } })
  }
}

export default function* Sagas() {
  yield takeLatest(FETCH_PRODUCTS, onLoadData)
}
